import { Map } from 'immutable';
// - Import action types
import { CommentActionType } from 'constants/commentActionType';
import { CommentState } from './CommentState';
/**
 * Comment reducer
 * @param state
 * @param action
 */
export var commentReducer = function (state, action) {
    if (state === void 0) { state = Map(new CommentState()); }
    var payload = action.payload;
    switch (action.type) {
        /* _____________ CRUD _____________ */
        case CommentActionType.ADD_COMMENT:
            return state
                .setIn(['postComments', payload.postId, payload.id], payload);
        case CommentActionType.ADD_COMMENT_LIST:
            return state
                .mergeIn(['postComments'], payload)
                .set('loaded', true);
        case CommentActionType.UPDATE_COMMENT:
            var comment_1 = payload.comment;
            return state
                .updateIn(['postComments', comment_1.postId, comment_1.id, 'text'], function (text) { return comment_1.text; });
        case CommentActionType.DELETE_COMMENT:
            return state.deleteIn(['postComments', payload.postId, payload.id]);
        case CommentActionType.CLOSE_COMMENT_EDITOR:
            return state
                .setIn(['editorStatus', payload.postId, payload.id], false);
        case CommentActionType.OPEN_COMMENT_EDITOR:
            return state
                .setIn(['editorStatus', payload.postId, payload.id], true);
        case CommentActionType.CLEAR_ALL_DATA_COMMENT:
            return Map(new CommentState());
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/comments/commentReducer.ts
// module id = 557
// module chunks = 50